(function () {
  if (window.dripnordTabManagerInitialized) return;

  window.dripnordTabManagerInitialized = true;

  window.openTabFeed = function (evt, sectionId, tabName) {
    const tabcontent = document.getElementsByClassName(
      "products-feed__tabcontent--" + sectionId
    );
    for (let i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    const tablinks = document.getElementsByClassName(
      "products-feed__tablinks--" + sectionId
    );
    for (let i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(
        " active",
        ""
      );
    }

    const activeTab = document.getElementById(tabName);
    if (!activeTab || !evt.currentTarget) return;

    activeTab.style.display = "block";
    evt.currentTarget.className += " active";
  };

  function openDefaultTabs(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll("[data-default-open]").forEach(el => {
      el.click();
    });
  }

  openDefaultTabs(document);

  window.addEventListener("shopify:section:load", event => {
    openDefaultTabs(event.target);
  });
})();
